
import Kartofel from "../../assets/img/Kartofel.png"
import Batat from "../../assets/img/Batat.png"
import CheesePotato from "../../assets/img/CheesePotato.png"
export const data = [
    {
        id: 1,
        img: Kartofel,
        name: "Kortofel Fry",
        netto: 150,
        Rus: "Картофель фри, специи",
        cost: 3000
    },
    {
        id: 2,
        img: Batat,
        name: "Batat",
        netto: 100,
        Rus: "Сладкий картофель",
        cost: 4000
    }, {
        id: 3,
        img: CheesePotato,
        name: "Cheese Potatoes",
        netto: 140,
        Rus: "С сыром чеддер и беконом",
        cost: 5000
    },
]